/**
 * Created by ys on 2017/10/31.
 */
import {encrypt} from './zEncrypt.js';
import CryptoJS from 'crypto-js'
export function encryptUtil() {
  var rawPswd = 'thisisvcarecity';
  var IV_SPEC = new encrypt().markMD5(rawPswd);
  this.jsencrypt = function (word, pwd) {

    var password=new encrypt().markMD5(pwd);

    var key =CryptoJS.enc.Hex.parse(password);


    var iv = CryptoJS.enc.Hex.parse(IV_SPEC);


    var srcs = CryptoJS.enc.Utf8.parse(word);


    var encrypted = CryptoJS.AES.encrypt(srcs, key, {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7});

    srcs = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    return srcs;

  };
  this.jsdecrypt = function(word, pwd) {
    var password=new encrypt().markMD5(pwd);
    var key =CryptoJS.enc.Hex.parse(password);

    var iv = CryptoJS.enc.Hex.parse(IV_SPEC);

    var decrypt = CryptoJS.AES.decrypt(word, key, {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7});

    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();

  }
}




// WEBPACK FOOTER //
// ./src/utils/zEncryptUtil.js